/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  PublicVehicleLogEntriesParams,
  SchemaValidationErrorResponse,
  StandardError,
  VehicleLogEntriesPublicList
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Public Vehicle Log Entries
 */
export const publicVehicleLogEntries = (
    username: MaybeRefOrGetter<string>,
    vehicleId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<PublicVehicleLogEntriesParams>,
 signal?: AbortSignal
) => {
      username = toValue(username);
vehicleId = toValue(vehicleId);
params = toValue(params);

      return axiosClient<VehicleLogEntriesPublicList>(
      {url: `/public/hangars/${username}/vehicles/${vehicleId}/log-entries`, method: 'GET',
        params, signal
    },
      );
    }




export const getPublicVehicleLogEntriesQueryKey = (username: MaybeRefOrGetter<string>,
    vehicleId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<PublicVehicleLogEntriesParams>,) => {
    return [
    'public','hangars',username,'vehicles',vehicleId,'log-entries', ...(params ? [params] : [])
    ] as const;
    }


export const getPublicVehicleLogEntriesQueryOptions = <TData = Awaited<ReturnType<typeof publicVehicleLogEntries>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(username: MaybeRefOrGetter<string>,
    vehicleId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<PublicVehicleLogEntriesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicVehicleLogEntries>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getPublicVehicleLogEntriesQueryKey(username,vehicleId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof publicVehicleLogEntries>>> = ({ signal }) => publicVehicleLogEntries(username,vehicleId,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(username) !== null && toValue(username) !== undefined && toValue(vehicleId) !== null && toValue(vehicleId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof publicVehicleLogEntries>>, TError, TData>
}

export type PublicVehicleLogEntriesQueryResult = NonNullable<Awaited<ReturnType<typeof publicVehicleLogEntries>>>
export type PublicVehicleLogEntriesQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Public Vehicle Log Entries
 */

export function usePublicVehicleLogEntries<TData = Awaited<ReturnType<typeof publicVehicleLogEntries>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 username: MaybeRefOrGetter<string>,
    vehicleId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<PublicVehicleLogEntriesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicVehicleLogEntries>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPublicVehicleLogEntriesQueryOptions(username,vehicleId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






